// extracted by mini-css-extract-plugin
export default {"rating":"CN-z","numberOfStars":"DN-z","count":"EN-z","barGraphSpacing":"FN-z","barGraph":"GN-z"};